module.exports = __webpack_public_path__ + "static/stranger-in-a-strange-land-1eb5fc2e9fae828f37148a4603b997ef.jpg";